import { createAction, props } from '@ngrx/store';
import { Tiles } from 'generated/graphql-types';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { TileSet } from '../models/tile-set.model';

export const loadTileSet = createAction('[Tile set type select] Load tile set', props<{ tileId: Tiles }>());

export const loadTileSetSuccess = createAction('[API] Load tile set success.', props<{ tileSet: TileSet }>());

export const loadTileSetFailure = createAction('[API] Load tile set failure.', props<SingleGraphError>());
